module.exports = __webpack_public_path__ + "img/logo-wordmark-transparent.496dff43.svg";